export default "__VITE_ASSET__CLVhm5Lq__"